import type { BlacklistItem } from '../schema/blacklist';
import { intFromMixed } from './coerce';

export function parseBlacklistArray(raw: unknown): BlacklistItem[] {
    if (!Array.isArray(raw)) return [];
    return raw.map(parseBlacklistItem);
}

function parseBlacklistItem(raw: unknown): BlacklistItem {
    const r = raw as Record<string, unknown>;
    return {
        characteristicId: r.option_id != null ? intFromMixed(r.option_id, 0) : null,
        valueId: r.choice_id != null ? intFromMixed(r.choice_id, 0) : null,
    };
}
